export default function searchFocus() {
  window.setTimeout(function () {
    $('.search-item').find('input').focus();
  }, 50);
}